<template>
    <div>
        <LoadingOverlay :loading="loading" />
        <div class="listingPattern">
            <div class="fixHeight ringlive-datalistWrap">
                <div class="listBoxes" v-for="(reward, index) in CallLastWeekData " :key="reward.id"
                @click="redirectProfile(reward.user.id, reward.user.profile_id, reward.user.charm_level)">
                    <div class="leftBxb">
                        <div class="s-no">{{ index + 1 }}</div>
                        <div class="listIconBox">
                            <div class="profPic">
                                <img :src='(reward.user.profile_images.length > 0) ? reward.user.profile_images[0].image_name : defaultUserImage'
                                alt="User Image" />
                                <!-- <img :src='(reward.user.profile_images.length > 0) ? reward.pic : defaultUserImage' alt="User Image" /> -->
                            </div>
                        </div>
                        <div class="name-lavel-box">
                            <div class="userName">{{ reward.user.name }}</div>
                            <div class="lavel-box">
                                <img :src="getLevelImage(reward.user?.charm_level || 0)" class="lavelImage" alt="level icon" />
                                <span class="lavel-value">{{ reward.user?.charm_level || 0 }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="rightBox">
                        <div class="rightBox-in">
                            <img :src='yellowClockIcon' class="beansIcon" alt="beans icons" />
                            {{ Math.floor(reward.total_duration / 60) }}
                            <span class="minTxt">min</span>
                            <!-- {{ reward.total_duration }} -->
                            <div class="userRewardsBox" v-if="reward.reward_coin > 0">
                                <span>Reward</span>{{ reward.reward_coin }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="personalDetails" class="listBoxes myselfBox">
                <div class="leftBxb">
                    <div class="s-no">-</div>
                    <div class="listIconBox">
                        <div class="profPic">
                            <img :src="personalDetails.pic.length > 0 ? personalDetails.pic : defaultUserImage"
                                alt="User Image" @error="setDefaultImage" />
                        </div>
                    </div>
                    <div class="name-lavel-box">
                        <div class="userName">{{ personalDetails.name }}</div>
                    </div>
                </div>
                <div class="rightBox">
                    <div class="rightBox-in">
                        <img :src='beansIcon' class="beansIcon" alt="beans icons" />
                        {{ personalDetails.total_earning }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import yellowClockIcon from '../../assets/images/yellowClock-Icon.png'
import defaultUserImage from '../../assets/images/default_profile.webp';
import LoadingOverlay from '../LoadingOverlay.vue'
export default {
    name: 'CallLastWeekTabCont',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            CallLastWeekData: [],
            personalDetails: null,
            yellowClockIcon: yellowClockIcon,
            defaultUserImage: defaultUserImage,
            loading: false,
        }
    },
    watch: {
        '$route.params.profile_id': 'fetchCallLastWeekData'
    },
    mounted() {
        this.fetchCallLastWeekData();
    },
    methods: {
        fetchCallLastWeekData() {
            this.loading= true;
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            const apiUrl = `api/top-call-weekly?type=last_week`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.CallLastWeekData = response.data.result.data;
                    this.personalDetails = response.data.result.personal_details;
                    this.checkAllImagesExist();
                })

                .catch(error => {
                    console.error("Error Featching This Week Data", error)
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        getLevelImage(charm_level) {            
            switch (true) {
                case charm_level === 0:
                return require('@/assets/images/charm-lavel-0.png');
                case charm_level === 1:
                return require('@/assets/images/charm-lavel-1.png');
                case charm_level === 2:
                return require('@/assets/images/charm-lavel-2.png');
                case charm_level === 3:
                return require('@/assets/images/charm-lavel-3.png');
                case charm_level === 4:
                return require('@/assets/images/charm-lavel-4.png');
                case charm_level === 5:
                return require('@/assets/images/charm-lavel-5.png');
                case charm_level >= 6 && charm_level <= 10:
                return require('@/assets/images/charm-lavel-6-10.png');
                case charm_level >= 11 && charm_level <= 15:
                return require('@/assets/images/charm-lavel-11-15.png');
                case charm_level >= 16 && charm_level <= 40:
                return require('@/assets/images/charm-lavel-16-20.png');
                default:
                return require('@/assets/images/charm-lavel-0.png'); // Ensure you have a default image
            }      
        },
        checkAllImagesExist() {
            this.CallLastWeekData.forEach(reward => {
                if (reward.length > 0) {
                    const imageUrl = reward.pic;
                    this.checkImageExists(imageUrl)
                        .then(exists => {
                            if (!exists) {
                                reward.pic = this.defaultUserImage;
                            }
                        });
                } else {
                    reward.pic = this.defaultUserImage;
                }
            });
        },
        checkImageExists(imageUrl) {
            return new Promise((resolve) => {
                var img = new Image();
                img.onload = function () {
                    resolve(true);
                };
                img.onerror = function () {
                    resolve(false);
                };
                img.src = imageUrl;
            });
        },

        setDefaultImage(event) {
            event.target.src = this.defaultUserImage;
        },
        
        redirectProfile(id, profile_id, level) {
            if (window.navigator.userAgent.indexOf("Android") > -1) {
                const baseURL = 'female-weekly-rewards';
                const params = {
                    id: id,
                    profile_id: profile_id,
                    level: level
                };
                const queryString = Object.keys(params)
                    .map(key => `${key}=${params[key]}`)
                    .join('&');
                const url = `${baseURL}?${queryString}`;
                //console.warn(url)
                Android.redirectProfile(url);
            }
        }
    },
}
</script>